export const EVENT_TYPE_CLICK = 'click';
export const EVENT_TYPE_VIEW = 'view';
